<script>
	import EventBus from '@EventBus';
	// Generalized Adapter Component
	export default {
		props: {
			adapterName: {
				type: String,
				default: '',
			},
			path: {
				type: String,
				default: '',
			},
			forceRoute: {
				type: String,
				default: null,
			},
			id: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				useComponent: '',
				adapter: {},
			};
		},
		computed: {
			convertToStyleClass() {
				const isDefault = (this.useComponent === 'Default');
				const name = (isDefault) ? this.adapterName : this.useComponent;
				const hyphenate = name.replace(/([a-z](?=[A-Z]))/g, '$1-');
				const lowercase = hyphenate.toLowerCase();
				const routePath = this.$route.name;
				let styles = {};
				styles[routePath] = true;
				styles[`${lowercase}-wrapper`] = true;
				return styles;
			},
			getComponent() {
				this.useComponent = this.setupComponent();
				return this.getComponentInitial();
			}
		},
		methods: {
			setupComponent() {
				const screen = this.$mq === 'mobile' ? 'mobile' : 'desktop';
				const adapterName = this.adapterName;
				const route = this.forceRoute || this.$route.name;
				const component = this.$layouts.getComponent({
					screen,
					route,
					adapter: adapterName,
				});
				this.adapter = {
					screen,
					route,
					adapter: component,
				};
				return component;
			},
			getComponentInitial() {
				const adapterName = this.adapterName;
				const componentMap = (useComponent) => {
					if (adapterName === '' || useComponent === '') { return null; }
					if (useComponent === 'Default') {
						useComponent = adapterName;
					}
					if (useComponent === 'null') {
						useComponent = null;
						EventBus.$emit('no-component',adapterName);
						return;
					}
					let path = this.path;
					if (path) {
						path += '/';
					}
					const componentPath = `${path}${adapterName}/${useComponent}`;
					const genericComponent = (resolve) => {
						require.ensure([], () => {
							resolve(require(`@/components/${componentPath}`));
						});
					};
					return genericComponent;
				};
				let useComponent = this.useComponent;
				if (useComponent === 'Default') {
					useComponent = adapterName;
				}
				return componentMap(useComponent);
			},
		},
		watch: {
			$mq(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.setupComponent();
				}
			}
		}
	}
</script>

<template>
	<div :class="convertToStyleClass" :id="id">
		<component :is="getComponent" :adapter="adapter">
		</component>
	</div>
</template>


// WEBPACK FOOTER //
// src/components/_Adapter.vue